import React from 'react'
import styles from './Summary.module.css'
import SummaryCard from './SummaryCard'

export default function Summary() {
    const cards = [
        {
            alt: '求人掲載',
            imagePc: '/pages/business/hotelslabo/summary_image_pc_1.png',
            imageSp: '/pages/business/hotelslabo/summary_image_sp_1.png',
        },
        {
            alt: 'ダイレクトリクルーティング',
            imagePc: '/pages/business/hotelslabo/summary_image_pc_2.png',
            imageSp: '/pages/business/hotelslabo/summary_image_sp_2.png',
        },
        {
            alt: 'エージェントサポート',
            imagePc: '/pages/business/hotelslabo/summary_image_pc_3.png',
            imageSp: '/pages/business/hotelslabo/summary_image_sp_3.png',
        },
    ]

    return (
        <section id='summary' className={styles.summary}>
            <h1>
                <span className={styles.summaryColor}>
                    ホテル・旅館業界特化の
                </span>
                <br />
                成果報酬型{' '}
                <span className={styles.br}>採用DXプラットフォーム</span>
            </h1>
            <ul className={styles.summaryImagePc}>
                {cards.map((card, index) => (
                    <SummaryCard
                        key={index}
                        alt={card.alt}
                        imagePc={card.imagePc}
                        imageSp={card.imageSp}
                        isSp={false}
                    />
                ))}
            </ul>
            <div className={styles.summaryImagePcBackground}></div>
            <div className={styles.summaryImageSpBackground}>
                <ul className={styles.summaryImageSp}>
                    {cards.map((card, index) => (
                        <SummaryCard
                            key={index}
                            alt={card.alt}
                            imagePc={card.imagePc}
                            imageSp={card.imageSp}
                            isSp={true}
                        />
                    ))}
                </ul>
            </div>
        </section>
    )
}
